import styled from "styled-components";

export const ReviewCard = styled("div")`
  display: flex;
  flex-direction: column;
  background-color: rgb(246, 248, 252);
  cursor: pointer;
  color: rgb(31, 41, 55);
  padding: 24px;
  border-radius: 12px;
  gap: 16px;
  min-width: 152px;
`;

export const ReviewLink = styled("a")`
  color: #6c5ce7;
  margin-left: 8px;

  &:hover {
    color: #6c5ce7;
  }
`;
